import {ErrorMessage, Field, useFormikContext} from "formik";
import {useIntl} from "react-intl";
import {cities, typeContract} from "../../../__mocks__/data";
import './applicant-info.scss';
import { JSXElementConstructor, ReactElement, ReactFragment, ReactPortal,useEffect , useState } from "react";
import _ from "lodash";
import { AdminService } from "../../../services";
import toast from "react-hot-toast";


interface FormPersonalInfoActivityProps {
    errors?: any;
    values?: any;
}

export function FormPersonalInfoActivity(props: FormPersonalInfoActivityProps) {
    const {errors, values} = props;
    const { setFieldValue } = useFormikContext<any>();
    const intl = useIntl();
    const [one] = useState(null);
    const [allCities, setAllCiudades] = useState(cities as any);
    const [ciudades, setCiudades] = useState(cities as any);
    const [TipoContrato, setAllTipoContrato] = useState([]);
    useEffect(()=>{
        allData()
        AdminService.getAllCiudades().then((Datos:any)=>{
            setAllCiudades(Datos.payload.data)
        })
    },[one])
    
    const allData=async ()=>{
        const tipocon= await AdminService.getTipoContrato();
     if(tipocon.payload.data.listTipoContr.Datos_TipoContrato.length>0){
        setAllTipoContrato(tipocon.payload.data.listTipoContr.Datos_TipoContrato)
        }
    }
    useEffect(()=>{
       if(allCities){
        
        let citiesDepent = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3'});
        setCiudades(citiesDepent)
       }
    },[allCities])

    const calcularAntiguedadAnios = (fechaIngresoISO: string, fechaCorte: Date = new Date()) => {
        // Contar años cumplidos (sin redondear hacia arriba) para evitar que 1.1 años se muestre como 2.
        const [y, m, d] = fechaIngresoISO.split('-').map(Number);
        if (!y || !m || !d) return 0;

        const start = new Date(Date.UTC(y, m - 1, d));
        const end = new Date(Date.UTC(
            fechaCorte.getFullYear(),
            fechaCorte.getMonth(),
            fechaCorte.getDate()
        ));

        if (start.getTime() > end.getTime()) return 0;

        let years = end.getUTCFullYear() - start.getUTCFullYear();
        const endMonth = end.getUTCMonth();
        const startMonth = start.getUTCMonth();
        const endDay = end.getUTCDate();
        const startDay = start.getUTCDate();
        if (endMonth < startMonth || (endMonth === startMonth && endDay < startDay)) {
            years -= 1;
        }
        return Math.max(0, years);
    };

    const actualizarAntiguedad = (dateValue: string) => {
        if (!dateValue) {
            setFieldValue('Pws_Ant_labo', '');
            return;
        }
        const dateStart = new Date(dateValue);
        const dateEnd = new Date();
        if (dateStart.getTime() > dateEnd.getTime()) {
            toast("La fecha de ingreso no debe ser mayor a la fecha actual");
            setFieldValue('Pws_Ant_labo', '');
        } else {
            const result = calcularAntiguedadAnios(dateValue, dateEnd);
            setFieldValue('Pws_Ant_labo', result);
        }
    };
    return (
        <div className="row container-border-app applicant-section applicant-activity-section">
               <div className="row applicant-section-header" >
                <div className="text-left">
                    
                <div className="col" style={{"textAlign":"left"}}>
                     <h3 >Actividad del solicitante</h3>

                </div>
                </div>
            </div>
            <div className="row applicant-fields-grid">
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_company_name"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Nom_empre"}
                               name={"Pws_Nom_empre"}
                               className={`${errors.Pws_Nom_empre ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_company_name"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Nom_empre"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_date_of_admission"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_fec_ingemp"}
                               name={"Pws_fec_ingemp"}
                               type={"date"}
                               placeholder={'MM/dd/YYYY'}
                               className={`${errors.Pws_fec_ingemp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}>
                            {({ field }: any) => (
                                <input
                                    {...field}
                                    type="date"
                                    id="Pws_fec_ingemp"
                                    placeholder="MM/dd/YYYY"
                                    className={errors.Pws_fec_ingemp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        actualizarAntiguedad(e.target.value);
                                    }}
                                />
                            )}
                        </Field>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_fec_ingemp"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_type_of_contract"})}</div>
                    <div className="display-flex">
                        <Field as="select"
                               className={`${errors.Pws_Tip_contra ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               name="Pws_Tip_contra">
                            <option value="">{intl.formatMessage({id: "placeholder_type_of_contract"})}</option>
                            {TipoContrato && TipoContrato.map((item:any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                                )
                            })}
                        </Field>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Tip_contra"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_labor_old"})}</div>
                    <div className="display-flex">
                        <Field type="hidden" name="Pws_Ant_labo"/>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>
                            {values?.Pws_Ant_labo ?? ''}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_job_that_performs"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Car_emp"}
                               name={"Pws_Car_emp"}
                               className={`${errors.Pws_Car_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_job_that_performs"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Car_emp"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_direct_boss"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Nom_Jefedi"}
                               name={"Pws_Nom_Jefedi"}
                               className={`${errors.Pws_Nom_Jefedi ? 'form-know-you-item-input-xxs display-flex input-error' : 'form-know-you-item-input-xxs display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_direct_boss"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Nom_Jefedi"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row applicant-fields-grid applicant-fields-grid-activity-secondary">
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_company_address"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Direc_emp"}
                               name={"Pws_Direc_emp"}
                               className={`${errors.Pws_Direc_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_company_address"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Direc_emp"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</div>
                    <div className="display-flex">
                        <Field as="select"
                               className={`${errors.Pws_Ciud_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               name="Pws_Ciud_emp"
                        >
                            <option value="">{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</option>
                            {ciudades && ciudades.ListCiudad.Datos_Ciudad.map((item: { s_codigo: string | number | readonly string[] | undefined; s_nombre: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; }, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                )
                            })}
                        </Field>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Ciud_emp"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_phone_1"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_tel_emp1"}
                               name={"Pws_tel_emp1"}
                               className={`${errors.Pws_tel_emp1 ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_phone_1"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_tel_emp1"/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_phone_2"})}</div>
                    <div className="display-flex">
                        <Field id={"Pws_tel_emp2"}
                               name={"Pws_tel_emp2"}
                               className={`${errors.Pws_tel_emp2 ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_phone_2"})}/>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_tel_emp2"/>
                        </div>
                    </div>
                </div>
                <div className="col"/>
                <div className="col"/>
            </div>
        </div>
    )
}
